export default "__VITE_ASSET__BzC5uUo9__"